import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormGroup, InputGroup, Button, ControlLabel, FormControl } from 'react-bootstrap';
import { required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type,step,min,max, readOnly, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} step={step} min={min} max={max} readOnly={readOnly} />
    {touched && ((error && <span className="error-text"> ({error})</span>) || (warning && <span>{warning}</span>))}
  </InputGroup>
);

const DefineRateForm = props => {
  const { handleSubmit, pristine, reset, submitting, initialValues} = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            id ="suite"
            name="suiteRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="Suite Rate"
          />
           <Field
            name="kingRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="King Rate"            
          />
           <Field
            name="doubleRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="Double Rate"            
          />
          <Field
            name="twobedRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="Two Bed Rate"            
          />
          <Field
            name="juniorsuiteRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="Junior Suite Rate"            
          />
          <Field
            name="twobedroomsuiteRate"
            type="number"
            step="0.00" 
            min="0.00"
            max="9999999999.99"
            component={renderBootstrapField}
            label="2 Bedroom Suite Rate"            
          />
        </FormGroup>
        <FormGroup>
          <Button bsStyle="success" type="submit">
            Apply
          </Button>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'defineRateForm', // a unique identifier for this form
  enableReinitialize : true,
})(DefineRateForm);



// WEBPACK FOOTER //
// src/routes/tours/components/DefineRateForm.js